/* =========================================================
   SMA Product Extensions
   - Curtain reveal: auto-opens 500ms after the section initializes
     (both desktop and mobile). Editor / design mode stays open.
   - Carousel: auto-play + dots
   ========================================================= */
(function () {
  'use strict';

  var CURTAIN_DELAY_MS = 500;

  // ---------- Curtain ----------
  function initCurtain(wrap) {
    if (!wrap || wrap.dataset.curtainInit === 'true') return;
    wrap.dataset.curtainInit = 'true';

    var open = function () {
      if (wrap.classList.contains('sma-opened')) return;

      // Mobile uses a JS-driven height reveal (0 -> content height -> auto) so
      // the "pull down" animates smoothly on iOS Safari, which does NOT animate
      // grid-template-rows / fr units. Desktop keeps its CSS width/grid reveal.
      var infoWrap = wrap.querySelector('.product__info-wrapper');
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // Measure full content height while still collapsed (overflow:hidden,
      // height:0). scrollHeight returns the full height regardless of clipping.
      var targetHeight = infoWrap ? infoWrap.scrollHeight : 0;

      wrap.setAttribute('data-curtain-state', 'open');
      wrap.classList.add('sma-opened');

      if (isMobile && infoWrap && !reduceMotion) {
        // Kick off the height transition: 0 -> measured px (inline style wins
        // over the CSS fallback height:auto, so we get a real animation).
        infoWrap.style.height = targetHeight + 'px';
        var onDone = function (e) {
          if (e.target !== infoWrap || e.propertyName !== 'height') return;
          // Release to auto so the column reflows freely (variant changes, etc.).
          infoWrap.style.height = 'auto';
          infoWrap.removeEventListener('transitionend', onDone);
        };
        infoWrap.addEventListener('transitionend', onDone);
      }
    };

    // In Shopify theme editor / design mode, keep curtain open immediately so
    // merchants can edit the info column without waiting for the animation.
    if (window.Shopify && window.Shopify.designMode) {
      open();
      return;
    }

    // Auto-open after 0.5s so the visitor first sees just the media column,
    // then the info column reveals like a curtain.
    setTimeout(open, CURTAIN_DELAY_MS);
  }

  // ---------- Carousel ----------
  function initCarousel(root) {
    if (!root || root.dataset.carouselInit === 'true') return;
    root.dataset.carouselInit = 'true';

    var track = root.querySelector('.sma-carousel__track');
    var slides = root.querySelectorAll('.sma-carousel__slide');
    var dots = root.querySelectorAll('.sma-carousel__dot');
    if (!track || slides.length === 0) return;

    var index = 0;
    var total = slides.length;
    var autoplayMs = parseInt(root.dataset.autoplayMs || '5000', 10);
    var timer = null;

    function go(i) {
      index = ((i % total) + total) % total;
      track.style.transform = 'translateX(calc(-' + (index * 100) + '% - ' + (index * 16) + 'px))';
      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.toggle('is-active', d === index);
        dots[d].setAttribute('aria-current', d === index ? 'true' : 'false');
      }
    }

    function next() { go(index + 1); }

    function start() {
      stop();
      if (autoplayMs > 0) {
        timer = setInterval(next, autoplayMs);
      }
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    for (var d = 0; d < dots.length; d++) {
      (function (i) {
        dots[i].addEventListener('click', function () {
          go(i);
          start(); // restart timer after manual interaction
        });
      })(d);
    }

    // Pause on hover (desktop)
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    // Pause when tab is hidden
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    go(0);
    start();
  }

  // ---------- Init on DOM ready ----------
  function init() {
    document.querySelectorAll('.sma-curtain-wrap').forEach(initCurtain);
    document.querySelectorAll('.sma-carousel').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when sections are re-rendered in the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    e.target.querySelectorAll('.sma-curtain-wrap').forEach(initCurtain);
    e.target.querySelectorAll('.sma-carousel').forEach(initCarousel);
  });
})();